import { useTranslation } from 'next-i18next'

interface Props {
  [key: string]: any
}

function ArrowLeftBoldIcon(props: Props): React.ReactElement {
  const { t } = useTranslation('generics')
  const { pathClassName, ...rest } = props
  return (
    <svg aria-label={t('backButton')} fill="none" viewBox="0 0 30 22" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M0.35028 9.62443L8.92713 0.377519C9.39405 -0.125879 10.1505 -0.125879 10.6175 0.377519L12.3179 2.21082C12.7848 2.71422 12.7848 3.5298 12.3179 4.0332L3.74034 13.2809C3.27342 13.7843 2.51693 13.7843 2.05001 13.2809L0.349557 11.4476C-0.116639 10.9442 -0.116639 10.1278 0.35028 9.62443Z"
        fill="#474141"
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M28.5952 7.80513L2.17261 7.80513L3.8014 14.0488L28.5952 14.0488C29.1946 14.0488 29.6811 13.5244 29.6811 12.8781V8.97583C29.6811 8.3296 29.1946 7.80513 28.5952 7.80513Z"
        fill="#474141"
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M0.35028 11.4488L9.65176 21.4762C10.1187 21.9796 10.8752 21.9796 11.3421 21.4762L13.0425 19.6429C13.5095 19.1395 13.5095 18.3239 13.0425 17.8205L3.75264 7.80564H2.03843L0.349556 9.62646C-0.116639 10.1291 -0.116639 10.9454 0.35028 11.4488Z"
        fill="#474141"
      />
    </svg>
  )
}

export default ArrowLeftBoldIcon
